import { FC } from 'react';

import { withA11yVisuallyHidden } from '@telialt/common-a11y/src/withA11yVisuallyHidden';
import { formatCurrency } from '@telialt/utils/src/helpers';

import { GIFT_SELECTION_TEST_ID } from '../../constants';
import { OldPriceElement } from './PriceTag.styles';

const OldPriceTagAccessible = withA11yVisuallyHidden(OldPriceElement);

type OldPriceProps = { children: string | number };

export const OldPrice: FC<OldPriceProps> = ({ children: oldPrice }) => {
    if (!oldPrice) {
        return null;
    }
    const priceFormatted = typeof oldPrice === 'number' ? formatCurrency(oldPrice) : oldPrice;

    return (
        <OldPriceTagAccessible accessible={priceFormatted} data-test={GIFT_SELECTION_TEST_ID.OLD_PRICE}>
            {priceFormatted}
        </OldPriceTagAccessible>
    );
};
